import { render, staticRenderFns } from "./PatientClaimList.vue?vue&type=template&id=bb2bc02a&"
import script from "./PatientClaimList.vue?vue&type=script&lang=js&"
export * from "./PatientClaimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports